import { useRequest } from 'ahooks'
import { message } from 'antd'
import { Message } from '@/components/message'
import { getSecyTemplate, GetSecurityTemplate, checkAvailableStatus } from '@/api/fishing-task'

// 获取安全教育模板
export const useGetSecyTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: GetSecurityTemplate) => getSecyTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取安全教育模板失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}

// 获取安全教育模板
export const useCheckAvailableStatus = () => {
  const { runAsync, loading, data } = useRequest(() => checkAvailableStatus(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取获取AI接口可用状态')
    },
  })

  return [runAsync, loading, data?.data?.items] as const
}

export const modifyHtmlString = htmlString => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  const container = doc.createElement('div')
  const id = `container${Math.floor(Math.random() * 10000000000)}`
  container.id = id

  // const firstDiv = doc.body.querySelector('div')
  // if (firstDiv) {
  //   container.appendChild(firstDiv.cloneNode(true))
  //   firstDiv.parentNode.replaceChild(container, firstDiv)
  // }
  const bodyContent = doc.body.innerHTML
  container.innerHTML = bodyContent
  doc.body.innerHTML = ''
  doc.body.appendChild(container)

  const styles = doc.querySelectorAll('style')
  styles.forEach(style => {
    let cssText = style.innerHTML
    // cssText = cssText.replace(/body[^{]*\{[^}]*\}/g, '')
    cssText = cssText.replace(/body/g, `#${id}`)
    cssText = cssText.replace(/([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g, (match, selector, tail) => {
      if (selector.trim().startsWith('@')) {
        return match
      }
      return (
        selector
          .split(',')
          .map(sel => {
            const trimmedSel = sel.trim()
            if (trimmedSel === `#${id}`) {
              return trimmedSel
            } else {
              return `#${id} ${trimmedSel}`
            }
          })
          .join(', ') + tail
      )
    })
    style.innerHTML = cssText
  })

  return new XMLSerializer().serializeToString(doc)
}
